module.exports = __webpack_public_path__ + "img/T5-A-xs_06.2928c324.png";